export function formatDateIso(dateString: string): string {
  return dateString.slice(0, 10);
}
